<template>
  <div class="wapper">
    <el-container style="100%">
      <el-main style="background:#fff;">
        <div class="table-wrap" v-show="listShow">
          <div class="handle-box3">
            <el-form :inline="true" ref="form" :model="searchForm" class="demo-form-inline">
              <div class="uers-left">
                <el-form-item label="搜索：">
                  <el-input v-model="searchForm.title" placeholder="标题"></el-input>
                </el-form-item>
                <el-form-item label>
                  <el-select
                    placeholder="模板类型"
                    clearable
                    v-model="searchForm.isEmail"
                    class="el-input-position"
                  >
                    <el-option label="全部" value="-1"></el-option>
                    <el-option label="邮件" value="1"></el-option>
                    <el-option label="短信" value="0"></el-option>
                    <el-option label="图片" value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="searchSubmit">搜索</el-button>
              </div>
              <div class="uers-right">
                <span class="btn-r">
                  <el-button type="primary" plain icon="el-icon-plus" @click="addSubmit">新增</el-button>
                </span>
              </div>
            </el-form>
          </div>
          <div class="tabbox">
            <el-table
              :data="dataList"
              height="100%"
              border
              class="tabbox"
              ref="multipleTable"
              :header-cell-style="{background:'#f2f6fc',color:'#606266'}"
              @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection" width="55" align="center"></el-table-column>
              <el-table-column prop="title" label="标题" align="center">
                <template slot-scope="scope">
                  <span>{{scope.row.title}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="isEmail" label="类型" width="150" align="center">
                <template slot-scope="scope">
                  <span>{{scope.row.isEmail==0?"短信模板":scope.row.isEmail==1?"邮件模板":"图片"}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="author" label="发送人" align="center">
                <template slot-scope="scope">
                  <span>{{scope.row.author}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="createDate" label="创建时间" align="center">
                <template slot-scope="scope">
                  <span>{{scope.row.createDate}}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button type="text" @click="handleEdit(scope.$index,scope.row)">编辑</el-button>
                  <el-button
                    type="text"
                    class="red"
                    @click="handleDelete(scope.$index, scope.row)"
                  >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="fb">
            <el-pagination
              class="pag"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 15, 20, 50, 100]"
              :page-size="pagesize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              background
            ></el-pagination>
          </div>
        </div>
        <DeleteDialog
          :delVisible="delVisible"
          @deleteData="deleteData"
          @handleCloseVisible="handleCloseVisible"
        ></DeleteDialog>
        <EditInvite :editShow="editShow" :editData="editData" @backFunStu="getFunStu"></EditInvite>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import EditInvite from "../../components/major/EditInvite";
import DeleteDialog from "../../components/public/DeleteConfim";

export default {
  data() {
    return {
      total: 0, //总条数
      currentPage: 1, //初始页
      pagesize: 10, // 每页的数据
      //表格高度适配
      tabheight: "",
      searchForm: {
        title: "",
        isEmail: "-1",
      },
      editData: {},
      listShow: true,
      delVisible: false,
      ticketCom_Id: "",
      editShow: false,
      dataList: [],
      multipleSelection: [],
      productId: localStorage.getItem("project_Id"),
    };
  },
  mounted() {
    // this.tabheight=(this.$refs.getheight.offsetHeight-165)
  },
  created() {
    this.searchSubmit();
  },
  methods: {
    handleSizeChange(val) {
      this.pagesize = val;
      this.searchSubmit();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.searchSubmit();
    },
    handleEdit(index, row) {
      this.editData = row;
      this.listShow = false;
      this.editShow = true;
    },
    searchSubmit() {
      var search = {
        name: this.searchForm.title,
        type: this.searchForm.isEmail,
        pageIndex: this.currentPage - 1,
        pageSize: this.pagesize,
        projectId: this.productId,
      };
      this.$axios.post("/Invite/Search", search).then((res) => {
        if (res.data.hasError == false) {
          this.dataList = [...res.data.data];
          this.total = res.data.total;
        }
      });
    },
    addSubmit() {
      this.ticketCom_Id ="";
      this.editData = null;
      this.listShow = false;
      this.editShow = true;
    },
    handleDelete(index, row) {
      this.ticketCom_Id = row.inviteId;
      this.delVisible = true;
    },
    deleteData() {
      this.$axios.delete(`/Invite/${this.ticketCom_Id}`).then((res) => {
        if (res.data.hasError) {
          this.$message.error(res.data.message);
        } else {
          this.$message.success("删除成功！");
          this.delVisible = false;
          this.searchSubmit();
        }
      });
    },
    handleCloseVisible() {
      this.ticketCom_Id = "";
      this.delVisible = false;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getFunStu() {
      this.listShow = true;
      this.editShow = false;
      this.searchSubmit();
    },
  },
  components: {
    EditInvite,
    DeleteDialog,
  },
};
</script>
<style lang="scss" scope>
.pag {
  position: absolute;
  bottom: 0;
}

.table-wrap {
  margin-left: 10px;
  height: 100%;
}
.el-main {
  border-radius: 5px;
  position: relative;
}
.uers-left {
  float: left;
}
.uers-right {
  float: right;
}
.el-dialog {
  height: auto;
}
</style>